<template>
  <div v-if="data" class="row-box">
    <WrapperField
      v-if="data.extractType"
      :widthForced="true"
      :data="createDataField({fieldValue: extractTypeMap[data.extractType]})"
    ></WrapperField>

    <WrapperField
      v-if="data.applicationRole && data.applicationRole !== 'APPLICANT'"
      :widthForced="true"
      :data="createDataField({fieldValue: roleMap[data.applicationRole]})"
    ></WrapperField>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

const extractTypeMap = {
  SHORT: 'краткой выписки (любому лицу)',
  OVERALL: 'краткой выписки (залогодателю или залогодержателю)',
  EXTENDED: 'расширенной выписки (залогодателю или залогодержателю)',
};
const roleMap = {
  APPLICANT_PLEGOR: 'залогодателем',
  APPLICANT_PLEDGEE: 'залогодержателем',
  APPLICANT_PLEDGE_MANAGER: 'управляющим залогом',
};

export default {
  name: 'Step2',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    roleMap,
    extractTypeMap,
  }),
};
</script>